import { computed } from '@angular/core';
import { patchState, signalStore, withMethods } from '@ngrx/signals';
import { setEntity, updateEntity, withEntities } from '@ngrx/signals/entities';

export type IrisDmsFolderStatus = 'InProgress' | 'Success' | 'Error';

export interface IrisDmsFolderRequestStatusI {
  id: string;
  status: IrisDmsFolderStatus;
}

const DEFAULT_REQUEST_TIME = 30000;

export const IrisDmsFolderRequestStatusStore = signalStore(
  { providedIn: 'root', protectedState: false },
  withEntities<IrisDmsFolderRequestStatusI>(),
  withMethods((
    store,
  ) => ({
    getFolderInfo: (folderId: string) => store.entityMap()[folderId],
    getFolderStatus: (folderId: string) => computed(() => store.entityMap()[folderId]?.status ?? 'Success'),
  })),
  withMethods((
    store,
  ) => ({
    setStatus: (folderId: string, status: IrisDmsFolderStatus) => {
      patchState(store, setEntity({ id: folderId, status }));
      if (status !== 'InProgress') {
        return;
      }
      setTimeout(() => {
        const folderInfo = store.getFolderInfo(folderId);
        if (folderInfo?.status === 'InProgress') {
          patchState(store, updateEntity({ id: folderId, changes: { status: 'Error' } }));
        }
      }, DEFAULT_REQUEST_TIME);
    },
    hasInProgressAction: (folderId: string) => computed(() => store.getFolderStatus(folderId)() === 'InProgress'),
  })),
  withMethods((store) => ({
    setInProgress: (folderId: string) => store.setStatus(folderId, 'InProgress'),
    setSuccess: (folderId: string) => store.setStatus(folderId, 'Success'),
    setError: (folderId: string) => store.setStatus(folderId, 'Error'),
  })),
);
